import createSagaMiddleware from "redux-saga";
import { createStore, applyMiddleware, compose } from "redux";

import { rootReducer } from "./reducers/rootReducer";
import { rootSaga } from "./saga/rootSaga";

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware))

);

sagaMiddleware.run(rootSaga);
